const HTML_ENTITIES = {
  amp: '&', apos: "'", lt: '<', gt: '>', quot: '"', nbsp: ' ',
  lsquo: '‘', rsquo: '’', sbquo: '‚', ldquo: '“', rdquo: '”', bdquo: '„',
  laquo: '«', raquo: '»', hellip: '…', ndash: '–', mdash: '—',
  copy: '©', reg: '®', trade: '™', deg: '°', plusmn: '±', times: '×', divide: '÷',
  ccedil: 'ç', Ccedil: 'Ç',
  ouml: 'ö', Ouml: 'Ö',
  uuml: 'ü', Uuml: 'Ü',
  auml: 'ä', Auml: 'Ä',
  euml: 'ë', Euml: 'Ë',
  iuml: 'ï', Iuml: 'Ï',
  acirc: 'â', Acirc: 'Â',
  ecirc: 'ê', Ecirc: 'Ê',
  icirc: 'î', Icirc: 'Î',
  ocirc: 'ô', Ocirc: 'Ô',
  ucirc: 'û', Ucirc: 'Û',
  agrave: 'à', Agrave: 'À',
  egrave: 'è', Egrave: 'È',
  igrave: 'ì', Igrave: 'Ì',
  ograve: 'ò', Ograve: 'Ò',
  ugrave: 'ù', Ugrave: 'Ù',
  aacute: 'á', Aacute: 'Á',
  eacute: 'é', Eacute: 'É',
  iacute: 'í', Iacute: 'Í',
  oacute: 'ó', Oacute: 'Ó',
  uacute: 'ú', Uacute: 'Ú',
  ntilde: 'ñ', Ntilde: 'Ñ', szlig: 'ß', yuml: 'ÿ', Yuml: 'Ÿ',
}

const decodeCodePoint = (value, radix) => {
  const codePoint = Number.parseInt(value, radix)
  return Number.isInteger(codePoint) && codePoint >= 0 && codePoint <= 0x10FFFF
    && !(codePoint >= 0xD800 && codePoint <= 0xDFFF)
    ? String.fromCodePoint(codePoint)
    : null
}

export const decodeHtmlEntities = (value) => String(value || '')
  .replace(/&#x([0-9a-f]+);/gi, (match, value) => decodeCodePoint(value, 16) ?? match)
  .replace(/&#(\d+);/g, (match, value) => decodeCodePoint(value, 10) ?? match)
  .replace(/&([a-z][a-z0-9]+);/gi, (match, entity) => HTML_ENTITIES[entity] ?? match)

// Search snippets and browser titles read better with straight quotes than
// typographic quotes, and do not need non-breaking spaces.
export const cleanMetaText = (value) => decodeHtmlEntities(value)
  .replace(/<[^>]*>/g, ' ')
  .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
  .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
  .replace(/\u00A0/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
